function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useRef, useState } from "react";
import { AccessibilityInfo, findNodeHandle, Platform, View } from "react-native";
import { Actor, Kind } from "@oui/lib/src/types";
import { useAccessibilityContext } from "./AccessibilityContext";
import { ChatInputArtifact } from "./ChatInputArtifact";
import { ChatInputButton } from "./ChatInputButton";
import { ChatInputCarousel } from "./ChatInputCarousel";
import { ChatInputChoice } from "./ChatInputChoice";
import { ChatInputContactsPicker } from "./ChatInputContactsPicker";
import { ChatInputMediaPicker } from "./ChatInputMediaPicker";
import { ChatInputMultipleChoice } from "./ChatInputMultipleChoice";
import { ChatInputSignature } from "./ChatInputSignature";
import { ChatInputSingleChoice } from "./ChatInputSingleChoice";
import { ChatInputSlider } from "./ChatInputSlider";
import { ChatInputText } from "./ChatInputText";
import { ChatInputTimePicker } from "./ChatInputTimePicker";
var EMPTY_ENVELOPE = {
    t: 0,
    ID: '',
    kind: Kind.NULL,
    props: {},
    from: Actor.NULL
};
/**
 * The ChatInput component manages the chat input interface, responding to
 * user interactions by adjusting its active state based on input envelope
 * changes and user activity. It handles different input types (text, choice,
 * button, etc.) and invokes appropriate rendering based on the current input
 * kind. The component maintains accessibility by focusing on the designated
 * input area when active, and it adjusts its height dynamically based on layout
 * changes.
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-53}
 */ export function ChatInput(props) {
    var _useState = _sliced_to_array(useState(!!props.curr), 2), active = _useState[0], setActive = _useState[1];
    var inactiveTimeoutRef = useRef(0);
    var announceForAccessibility = useAccessibilityContext().announceForAccessibility;
    var ref = useRef(null);
    var _useState1 = _sliced_to_array(useState(0), 2), height = _useState1[0], setHeight = _useState1[1];
    useEffect(function() {
        if (props.curr) {
            clearTimeout(inactiveTimeoutRef.current);
            inactiveTimeoutRef.current = 0;
            setActive(true);
            if (ref.current && Platform.OS !== 'web') {
                var handle = findNodeHandle(ref.current);
                if (handle) {
                    AccessibilityInfo.setAccessibilityFocus(handle);
                }
            }
        }
    }, [
        props.curr,
        announceForAccessibility
    ]);
    var setInactive = useCallback(function() {
        // clear remaining timeout if it hasn't yet run and set setInactive for other reasons
        clearTimeout(inactiveTimeoutRef.current);
        inactiveTimeoutRef.current = 0;
        setActive(false);
    }, []);
    var curr = props.curr || EMPTY_ENVELOPE;
    var input = function(e) {
        props.onInput(_object_spread({
            ID: curr.ID
        }, e));
        inactiveTimeoutRef.current = setTimeout(function() {
            setInactive();
        }, Platform.OS === 'web' && global.e2e ? 0 : 500);
    };
    useEffect(function() {
        if (props.lastTextWasUser && active && inactiveTimeoutRef.current) {
            setInactive();
        }
    }, [
        active,
        props.lastTextWasUser,
        setInactive
    ]);
    var el;
    if (active) {
        switch(curr.kind){
            case Kind.InputText:
                el = /*#__PURE__*/ _jsx(ChatInputText, _object_spread_props(_object_spread({}, curr.props), {
                    onInput: input,
                    lastTextContent: props.lastTextContent
                }));
                break;
            case Kind.InputChoice:
                el = /*#__PURE__*/ _jsx(ChatInputChoice, _object_spread_props(_object_spread({}, curr.props), {
                    onInput: input,
                    lastTextContent: props.lastTextContent
                }));
                break;
            case Kind.InputSingleChoice:
                el = /*#__PURE__*/ _jsx(ChatInputSingleChoice, _object_spread_props(_object_spread({}, curr.props), {
                    onInput: input,
                    lastTextContent: props.lastTextContent
                }));
                break;
            case Kind.InputMultipleChoice:
                el = /*#__PURE__*/ _jsx(ChatInputMultipleChoice, _object_spread_props(_object_spread({}, curr.props), {
                    onInput: input,
                    lastTextContent: props.lastTextContent
                }));
                break;
            case Kind.InputButton:
                el = /*#__PURE__*/ _jsx(ChatInputButton, _object_spread_props(_object_spread({}, curr.props), {
                    onInput: input
                }));
                break;
            case Kind.InputSlider:
                el = /*#__PURE__*/ _jsx(ChatInputSlider, _object_spread_props(_object_spread({}, curr.props), {
                    onInput: input
                }));
                break;
            case Kind.InputCarousel:
                return /*#__PURE__*/ _jsx(View, {
                    style: {
                        backgroundColor: '#eee'
                    },
                    children: /*#__PURE__*/ _jsx(ChatInputCarousel, _object_spread_props(_object_spread({}, curr.props), {
                        onInput: input
                    }))
                });
            case Kind.InputTimePicker:
                el = /*#__PURE__*/ _jsx(ChatInputTimePicker, _object_spread_props(_object_spread({}, curr.props), {
                    onInput: input
                }));
                break;
            case Kind.InputContactsPicker:
                el = /*#__PURE__*/ _jsx(ChatInputContactsPicker, _object_spread_props(_object_spread({}, curr.props), {
                    onInput: input
                }));
                break;
            case Kind.InputSignature:
                el = /*#__PURE__*/ _jsx(ChatInputSignature, _object_spread_props(_object_spread({}, curr.props), {
                    onInput: input
                }));
                break;
            case Kind.InputMediaPicker:
                el = /*#__PURE__*/ _jsx(ChatInputMediaPicker, _object_spread_props(_object_spread({}, curr.props), {
                    onInput: input
                }));
                break;
            case Kind.InputArtifact:
                el = /*#__PURE__*/ _jsx(ChatInputArtifact, _object_spread_props(_object_spread({}, curr.props), {
                    onInput: input
                }));
                break;
        }
    } else {
        el = null;
    }
    return /*#__PURE__*/ _jsxs(View, {
        style: [
            {
                zIndex: 2
            },
            el ? {
                minHeight: 48
            } : undefined
        ],
        onLayout: function(e) {
            if (e.nativeEvent.layout.height !== height) {
                setHeight(e.nativeEvent.layout.height);
                props.onInputChangeHeight(e.nativeEvent.layout.height);
            }
        },
        children: [
            /*#__PURE__*/ _jsx(View, {
                ref: ref,
                accessible: true,
                "aria-label": "Chat input",
                role: "heading",
                // We need an accessible ref to focus on when chat input is activated. However, we cannot
                // use the parent View because on iOS it doesn't allow swiping to focus on children
                style: {
                    height: 5,
                    width: '100%',
                    marginBottom: -5
                }
            }),
            el
        ]
    });
}
